// extracted by mini-css-extract-plugin
export default {"main":"_18cff38c7d ccfde7e1f6","xmark":"c40719dcce","fl_img":"_53c3bec2a0 _03ca1fd9b9"};